"use client";

import { useLocale } from "@calcom/lib/hooks/useLocale";
import { Button } from "@calcom/ui/components/button";

// Kept out of the initial HTML deliberately: this string only exists inside a click
// handler, not a static href, so a plain crawler that just follows links on the page
// never fetches the (currently ~130MB) archive. See planning/AGPL-SOURCE-COMPLIANCE-PLAN.md.
const ARCHIVE_PATH = "/source.tar.gz";

const SourceView = () => {
  const { t } = useLocale();

  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center gap-6 p-6 text-center">
      <p className="text-emphasis text-sm">{t("agpl_source_notice")}</p>
      <Button
        className="justify-center"
        onClick={() => {
          window.location.href = ARCHIVE_PATH;
        }}>
        {t("download_source_code")}
      </Button>
    </div>
  );
};

export default SourceView;
